import * as Sentry from "@sentry/react";

interface ActiveStepSpan<Step extends string> {
    step: Step;
    span: Sentry.Span;
}

export class StepTimeline<Step extends string> {
    private activeStep: ActiveStepSpan<Step> | null = null;

    constructor(
        private readonly parentSpan: Sentry.Span,
        private readonly stepSpanOp: string,
    ) {}

    enter(step: Step): Sentry.Span {
        this.activeStep?.span.end();
        const span = Sentry.startInactiveSpan({ name: step, op: this.stepSpanOp, parentSpan: this.parentSpan });
        this.activeStep = { step, span };
        return span;
    }

    finish(): void {
        this.activeStep?.span.end();
        this.activeStep = null;
    }

    stepInProgress(): Step | null {
        return this.activeStep?.step ?? null;
    }
}
